import { stateProps, actionProps } from "../types/index";
import * as doctorInfo from "../constants/index";
import { nextButtonProcess } from "../utils/nextButtonProcess";
import { checkFormField } from "../utils/checkFormField";

const defaultState: stateProps = {
  step: 0,
  isEmptyTitleField: true,
  title: "",
  firstName: "",
  isEmptyFirstName: true,
  lastName: "",
  isEmptyLastName: true,
  email: "",
  isEmptyAndValidEmail: true,
  isEmptyGenderField: false,
  degree: "",
  isEmptyDegree: true,
  regiNumber: "",
  isEmptyRegiNumber: true,
  qualifications: "",
  isEmptyQualifications: true,
  specialities: [],
  speciality: {},
  isEmptySpeciality: true,
  customSpeciality: "",
  gender: "",
  price: "",
  pcurrency: "",
  phone: "",
  practising: "",
  isEmptyPractising: false,
  bankName: "",
  isEmptyBankName: true,
  branchName: "",
  isEmptyBranchName: true,
  acntHolder: "",
  isEmptyAcntHolder: true,
  acntNumber: 0,
  isEmptyAcntNumber: true,
  isEmptyLanguagesField: true,
  languages: [],
  isEmptyTimeSlotField: true,
  timeslot: [
    {
      day: "Monday",
      status: false,
      timeslots: [],
    },
    {
      day: "Tuesday",
      status: false,
      timeslots: [],
    },
    {
      day: "Wednesday",
      status: false,
      timeslots: [],
    },
    {
      day: "Thursday",
      status: false,
      timeslots: [],
    },
    {
      day: "Friday",
      status: false,
      timeslots: [],
    },
    {
      day: "Saturday",
      status: false,
      timeslots: [],
    },
    {
      day: "Sunday",
      status: false,
      timeslots: [],
    },
  ],
  isEmptyBoardCertifiedField: false,
  boardCertified: "",
  isEmptyTermsAndConditionsField: true,
  termsAndConditions: "",
  isEmptySignatureImageField: true,
  signatureImage: "",
  isEmptyProfileImageField: true,
  profileImage: "",
  isEmptyNicImageField: true,
  nicImage: "",
  isEmptySealImageField: true,
  sealImage: "",
  isEmptySlmcCertificateImageField: false,
  slmcCertificateImage: "",
  isEmptySlmcIDImageField: true,
  slmcIDImage: "",
  isEmptyProofOfQualificationImageField: true,
  proofOfQualificationImage: "",
  isEmptyPhone: true,
  isEmptyPrice: true,
  doctorCreateStatus: false,
  errorData: {
    status: false,
    msg: "",
  },
  errorDataSubmit: {
    status: false,
    msg: "",
  },
};

const doctorInfoReducer = (state = defaultState, action: actionProps) => {
  switch (action.type) {
    case doctorInfo.nextButton: {
      state = nextButtonProcess(state);
      return state;
    }
    case doctorInfo.backButton: {
      return {
        ...state,
        step: state.step - 1,
      };
    }
    case doctorInfo.changeTitle:
      return {
        ...state,
        title: action.title,
        isEmptyTitleField: checkFormField("title", action),
      };
    case doctorInfo.enterFirstName:
      return {
        ...state,
        firstName: action.firstName,
        isEmptyFirstName: checkFormField("firstName", action),
      };
    case doctorInfo.enterLastName:
      return {
        ...state,
        lastName: action.lastName,
        isEmptyLastName: checkFormField("lastName", action),
      };
    case doctorInfo.enterEmail:
      return {
        ...state,
        email: action.email,
        isEmptyAndValidEmail: action.isEmptyAndValidEmail,
      };
    case doctorInfo.enterDegree:
      return {
        ...state,
        degree: action.degree,
        isEmptyDegree: checkFormField("degree", action),
      };
    case doctorInfo.enterRegiNumber:
      return {
        ...state,
        regiNumber: action.regiNumber,
        isEmptyRegiNumber: checkFormField("regiNumber", action),
      };
    case doctorInfo.enterQualifications:
      return {
        ...state,
        qualifications: action.qualifications,
        isEmptyQualifications: checkFormField("qualifications", action),
      };
    case doctorInfo.changeSpeciality:
      return {
        ...state,
        speciality: action.speciality,
        isEmptySpeciality: checkFormField("speciality", action),
      };
    case doctorInfo.changeCustomSpeciality:
      return {
        ...state,
        customSpeciality: action.customSpeciality,
      };
    case doctorInfo.enterPractising:
      return {
        ...state,
        practising: action.practising,
      };
    case doctorInfo.enterBankName:
      return {
        ...state,
        bankName: action.bankName,
        isEmptyBankName: checkFormField("bankName", action),
      };
    case doctorInfo.enterBranchName:
      return {
        ...state,
        branchName: action.branchName,
        isEmptyBranchName: checkFormField("branchName", action),
      };
    case doctorInfo.enterAcntHolderName:
      return {
        ...state,
        acntHolder: action.acntHolder,
        isEmptyAcntHolder: checkFormField("acntHolder", action),
      };
    case doctorInfo.enterAcntNumber:
      return {
        ...state,
        acntNumber: action.acntNumber,
        isEmptyAcntNumber: checkFormField("acntNumber", action),
      };
    case doctorInfo.changeGender:
      return {
        ...state,
        gender: action.gender,
      };
    case doctorInfo.changeLanguage:
      return {
        ...state,
        languages: action.languages,
        isEmptyLanguagesField: checkFormField("languages", action),
      };
    case doctorInfo.changeTimeSlot:
      return {
        ...state,
        timeslot: action.timeslot,
        isEmptyTimeSlotField: checkFormField("timeslot", action),
      };
    case doctorInfo.changeBoardCertified:
      return {
        ...state,
        boardCertified: action.boardCertified,
      };
    case doctorInfo.changeTermsAndConditions:
      return {
        ...state,
        termsAndConditions: action.termsAndConditions,
        isEmptyTermsAndConditionsField: checkFormField("termsAndConditions", action),
      };
    case doctorInfo.changePrice:
      return {
        ...state,
        price: action.price,
        isEmptyPrice: checkFormField("price", action),
      };
    case doctorInfo.changeCurrency:
      return {
        ...state,
        pcurrency: action.pcurrency,
      };
    case doctorInfo.changePhoneNumber:
      return {
        ...state,
        phone: action.phone,
        isEmptyPhone: checkFormField("phone", action),
      };
    case doctorInfo.changeSignatureImage:
      return {
        ...state,
        signatureImage: action.signatureImage,
        isEmptySignatureImageField: checkFormField("signatureImage", action),
      };
    case doctorInfo.changeProfileImage:
      return {
        ...state,
        profileImage: action.profileImage,
        isEmptyProfileImageField: checkFormField("profileImage", action),
      };
    case doctorInfo.changeNICImage:
      return {
        ...state,
        nicImage: action.nicImage,
        isEmptyNicImageField: checkFormField("nicImage", action),
      };
    case doctorInfo.changeSealImage:
      return {
        ...state,
        sealImage: action.sealImage,
        isEmptySealImageField: checkFormField("sealImage", action),
      };
    case doctorInfo.changeSLMCCertificateImage:
      return {
        ...state,
        slmcCertificateImage: action.slmcCertificateImage,
      };
    case doctorInfo.changeSLMCIDImage:
      return {
        ...state,
        slmcIDImage: action.slmcIDImage,
        isEmptySlmcIDImageField: checkFormField("slmcIDImage", action),
      };
    case doctorInfo.changeProofOfQualificationImage:
      return {
        ...state,
        proofOfQualificationImage: action.proofOfQualificationImage,
        isEmptyProofOfQualificationImageField: checkFormField("proofOfQualificationImage", action),
      };
    case doctorInfo.setLanguages:
      return {
        ...state,
        languages: action.languages,
      };
    case doctorInfo.setSpecialities:
      return {
        ...state,
        specialities: action.specialities,
      };
    case doctorInfo.setStatusDoctorCreate:
      return {
        ...state,
        doctorCreateStatus: action.doctorCreateStatus,
      };
    case doctorInfo.setStatusError:
      return {
        ...state,
        errorData: action.errorData,
      };
    case doctorInfo.setStatusErrorSubmit:
      return {
        ...state,
        errorDataSubmit: action.errorDataSubmit,
        step: action.errorDataSubmit.status === true ? state.step - 1 : state.step,
      };
    default:
      return state;
  }
};

export default doctorInfoReducer;
